// A „Jelentkezés önkéntesnek” oldal (v191, a titkár leírása szerint): közvetlenül megosztható (#/jelentkezes), telefonon is rövid, jól olvasható.
// Nem tag is eléri (elég a Google-belépés); a jelentkezés nem ad tagsági hozzáférést. Szövegek: jelentkezesSzovegek.js (hu / en / ja).
// A beírás NEM rajzol újra (a fókusz és a kurzor maradjon): a kezelők csak az állapotot frissítik; újrarajzolás csak lépésváltáskor / állapotváltáskor.

import { el } from "./dom.js";
import { jt, allapotFelirat } from "./jelentkezesSzovegek.js";

const SZOVEGES = [
  { kulcs: "displayName", cimke: "fDisplayName", tipus: "text", kotelezo: true },
  { kulcs: "country", cimke: "fCountry", tipus: "text" },
  { kulcs: "timezone", cimke: "fTimezone", tipus: "text" },
  { kulcs: "language", cimke: "fLanguage", tipus: "text", kotelezo: true },
];
const KOZOS_KERDESEK = [
  { kulcs: "motivation", cimke: "fMotivation", tipus: "area", kotelezo: true },
  { kulcs: "experience", cimke: "fExperience", tipus: "area", kotelezo: true },
  { kulcs: "hoursPerWeek", cimke: "fHours", tipus: "text", kotelezo: true },
  { kulcs: "startFrom", cimke: "fStart", tipus: "text" },
  { kulcs: "reikiRelation", cimke: "fReiki", tipus: "area", kotelezo: true },
];
const TESZTELO_KERDESEK = [{ kulcs: "device", cimke: "fDevice", tipus: "text", kotelezo: true }];
const ADMIN_KERDESEK = [
  { kulcs: "adminExperience", cimke: "fAdminExperience", tipus: "area" },
  { kulcs: "adminTasks", cimke: "fAdminTasks", tipus: "area" },
];

const SZEREPEK = ["tester", "admin"];

/** A mezők legnagyobb hossza (karakter): a szerver TEXT_FIELDS-ének tükre (a teszt egyezteti). Egy túl hosszú mező a TELJES mentést elutasíttatná. */
export const HOSSZ = {
  displayName: 80, country: 80, timezone: 100, language: 100, motivation: 1500, experience: 1500, hoursPerWeek: 120, startFrom: 200,
  reikiRelation: 1500, device: 200, adminExperience: 1000, adminTasks: 500,
};

function mezo(uiLang, def, ertek, kezelok) {
  const sor = el("div", { class: "apply-field" });
  const id = "apply-" + def.kulcs;
  sor.appendChild(el("label", { class: "panel-label", for: id, text: jt(uiLang, def.cimke) + (def.kotelezo ? " *" : "") }));
  const maxlength = String(HOSSZ[def.kulcs] || 1500);
  const input = def.tipus === "area" ? el("textarea", { id, class: "panel-input apply-input", rows: "4", maxlength }) : el("input", { id, class: "panel-input apply-input", type: "text", maxlength });
  input.value = ertek || "";
  // Látható karakterszámláló („62 / 200”): a jelentkező lássa a korlátot, mielőtt eléri; a beírás nem rajzol újra, csak a számláló szövege változik
  const max = HOSSZ[def.kulcs] || 1500;
  const szamlalo = el("div", { class: "hint apply-counter", id: id + "-counter", "aria-hidden": "true" });
  const frissit = () => {
    const n = [...input.value].length;
    szamlalo.textContent = `${n} / ${max}`;
    szamlalo.classList.toggle("full", n >= max);
    szamlalo.classList.toggle("near", n < max && n >= Math.floor(max * 0.9));
  };
  frissit();
  input.addEventListener("input", () => { frissit(); kezelok.onChange(def.kulcs, input.value); });
  input.setAttribute("aria-describedby", id + "-counter");
  sor.appendChild(input);
  sor.appendChild(szamlalo);
  return sor;
}

function blokk(cim, szamlalo, tartalom) {
  const b = el("section", { class: "apply-block" });
  b.appendChild(el("h3", { class: "apply-block-title", text: cim }));
  for (const x of tartalom) b.appendChild(x);
  return b;
}

/** Az űrlap (szerkeszthető piszkozat). model.vazlat: { answers, roles, consent }. */
function urlap(uiLang, model, kezelok) {
  const v = model.vazlat || { answers: {}, roles: [], consent: {} };
  const a = v.answers || {};
  const doboz = el("div", { class: "apply-form" });
  doboz.appendChild(el("p", { class: "hint", text: jt(uiLang, "formHint") }));

  for (const d of SZOVEGES) doboz.appendChild(mezo(uiLang, d, a[d.kulcs], kezelok));

  // Szerepek: egy vagy mindkettő
  const szerepek = el("fieldset", { class: "apply-roles" });
  szerepek.appendChild(el("legend", { class: "panel-label", text: jt(uiLang, "fRoles") + " *" }));
  const blokkok = {};
  for (const r of SZEREPEK) {
    const id = "apply-role-" + r;
    const cb = el("input", { type: "checkbox", id });
    cb.checked = Array.isArray(v.roles) && v.roles.includes(r);
    cb.addEventListener("change", () => {
      kezelok.onRoles(r, cb.checked);
      if (blokkok[r]) blokkok[r].style.display = cb.checked ? "" : "none";
    });
    const cimke = el("label", { class: "apply-role", for: id });
    cimke.appendChild(cb);
    cimke.appendChild(document.createTextNode(" " + jt(uiLang, r === "tester" ? "roleNames_tester" : "roleNames_admin")));
    szerepek.appendChild(cimke);
  }
  doboz.appendChild(szerepek);

  for (const d of KOZOS_KERDESEK) doboz.appendChild(mezo(uiLang, d, a[d.kulcs], kezelok));

  // Tesztelőknek
  const tesztelo = blokk(jt(uiLang, "testerSection"), null, [
    ...TESZTELO_KERDESEK.map((d) => mezo(uiLang, d, a[d.kulcs], kezelok)),
    (() => {
      const sor = el("fieldset", { class: "apply-field apply-bug" });
      sor.appendChild(el("legend", { class: "panel-label", text: jt(uiLang, "fBugReport") }));
      for (const [ertek, kulcs] of [["yes", "yes"], ["no", "no"]]) {
        const id = "apply-bug-" + ertek;
        const rb = el("input", { type: "radio", name: "apply-bug", id });
        rb.checked = a.bugReport === ertek;
        rb.addEventListener("change", () => { if (rb.checked) kezelok.onChange("bugReport", ertek); });
        const l = el("label", { class: "apply-role", for: id });
        l.appendChild(rb);
        l.appendChild(document.createTextNode(" " + jt(uiLang, kulcs)));
        sor.appendChild(l);
      }
      return sor;
    })(),
  ]);
  tesztelo.style.display = Array.isArray(v.roles) && v.roles.includes("tester") ? "" : "none";
  blokkok.tester = tesztelo;
  doboz.appendChild(tesztelo);

  // Adminisztrációra jelentkezőknek
  const admin = blokk(jt(uiLang, "adminSection"), null, ADMIN_KERDESEK.map((d) => mezo(uiLang, d, a[d.kulcs], kezelok)));
  admin.style.display = Array.isArray(v.roles) && v.roles.includes("admin") ? "" : "none";
  blokkok.admin = admin;
  doboz.appendChild(admin);

  // Adatkezelés és megerősítések
  const adat = el("section", { class: "apply-privacy" });
  adat.appendChild(el("h3", { class: "apply-block-title", text: jt(uiLang, "privacyTitle") }));
  adat.appendChild(el("p", { class: "hint", text: jt(uiLang, "privacyText") }));
  for (const [kulcs, szoveg] of [["volunteer", "consentVolunteer"], ["privacy", "consentPrivacy"]]) {
    const id = "apply-consent-" + kulcs;
    const cb = el("input", { type: "checkbox", id });
    cb.checked = v.consent && v.consent[kulcs] === true;
    cb.addEventListener("change", () => kezelok.onConsent(kulcs, cb.checked));
    const l = el("label", { class: "apply-role", for: id });
    l.appendChild(cb);
    l.appendChild(document.createTextNode(" " + jt(uiLang, szoveg) + " *"));
    adat.appendChild(l);
  }
  doboz.appendChild(adat);

  doboz.appendChild(el("div", { id: "apply-save-status", class: "hint apply-save-status", role: "status", text: "" }));
  doboz.appendChild(el("button", { type: "button", class: "primary-btn apply-next", text: jt(uiLang, "next"), onclick: kezelok.onNext }));
  return doboz;
}

const MEZO_FELIRAT = {
  displayName: "fDisplayName", country: "fCountry", timezone: "fTimezone", language: "fLanguage", motivation: "fMotivation", experience: "fExperience",
  hoursPerWeek: "fHours", startFrom: "fStart", reikiRelation: "fReiki", device: "fDevice", bugReport: "fBugReport", adminExperience: "fAdminExperience", adminTasks: "fAdminTasks",
};
const HIANY_FELIRAT = { roles: "fRoles", adminExperience: "fAdminExperience", country: "fCountry", "consent.volunteer": "consentVolunteer", "consent.privacy": "consentPrivacy" };

/** Átnézés beküldés előtt. */
function attekintes(uiLang, model, kezelok) {
  const v = model.vazlat || { answers: {}, roles: [], consent: {} };
  const doboz = el("div", { class: "apply-review" });
  doboz.appendChild(el("h2", { text: jt(uiLang, "reviewTitle") }));
  doboz.appendChild(el("p", { class: "hint", text: jt(uiLang, "reviewHint") }));
  const lista = el("dl", { class: "apply-review-list" });
  const sor = (cimke, ertek) => {
    lista.appendChild(el("dt", { text: cimke }));
    lista.appendChild(el("dd", { text: ertek || "—" }));
  };
  for (const k of ["displayName", "country", "timezone", "language"]) sor(jt(uiLang, MEZO_FELIRAT[k]), v.answers[k]);
  sor(jt(uiLang, "fRoles"), (v.roles || []).map((r) => jt(uiLang, r === "tester" ? "roleNames_tester" : "roleNames_admin")).join(", "));
  for (const k of ["motivation", "experience", "hoursPerWeek", "startFrom", "reikiRelation"]) sor(jt(uiLang, MEZO_FELIRAT[k]), v.answers[k]);
  if ((v.roles || []).includes("tester")) {
    sor(jt(uiLang, MEZO_FELIRAT.device), v.answers.device);
    sor(jt(uiLang, MEZO_FELIRAT.bugReport), v.answers.bugReport ? jt(uiLang, v.answers.bugReport) : "");
  }
  if ((v.roles || []).includes("admin")) for (const k of ["adminExperience", "adminTasks"]) sor(jt(uiLang, MEZO_FELIRAT[k]), v.answers[k]);
  doboz.appendChild(lista);
  const hiany = Array.isArray(model.hiany) ? model.hiany : [];
  if (hiany.length > 0) {
    doboz.appendChild(el("div", { class: "panel-status err apply-missing", text: jt(uiLang, "missing") + " " + hiany.map((k) => jt(uiLang, HIANY_FELIRAT[k] || MEZO_FELIRAT[k] || k).replace(/\s*\*$/, "")).join("; ") }));
  }
  if (model.kuldesHiba === true) doboz.appendChild(el("div", { class: "panel-status err apply-submit-failed", text: jt(uiLang, "submitFailed") }));
  const gombok = el("div", { class: "panel-row" });
  gombok.appendChild(el("button", { type: "button", class: "neutral-btn apply-back", text: jt(uiLang, "back"), onclick: kezelok.onBack }));
  gombok.appendChild(el("button", { type: "button", class: "primary-btn apply-submit", text: model.busy ? "…" : jt(uiLang, "submit"), disabled: model.busy === true || hiany.length > 0, onclick: kezelok.onSubmit }));
  doboz.appendChild(gombok);
  return doboz;
}

/** A beküldött jelentkezés oldala: azonosító, állapot, üzenetek, válasz, visszavonás. */
function allapotOldal(uiLang, model, kezelok) {
  const app = model.app;
  const doboz = el("div", { class: "apply-status" });
  if (app.status === "withdrawn") {
    doboz.appendChild(el("h2", { text: jt(uiLang, "withdrawnNote") }));
  } else {
    doboz.appendChild(el("h2", { text: jt(uiLang, "sentTitle") }));
  }
  if (app.appId) doboz.appendChild(el("p", { class: "apply-appid" }, [el("span", { class: "hint", text: jt(uiLang, "appId") + ": " }), el("strong", { text: app.appId })]));
  doboz.appendChild(el("p", { class: "apply-state" }, [el("span", { class: "hint", text: jt(uiLang, "statusLabel") + ": " }), el("strong", { class: "apply-state-name apply-state-" + app.status, text: allapotFelirat(uiLang, app.status) })]));
  if (app.erased) doboz.appendChild(el("p", { class: "hint", text: jt(uiLang, "erasedNote") }));
  if (app.status === "accepted") doboz.appendChild(el("p", { class: "panel-status ok", text: jt(uiLang, "acceptedNote") }));
  if (app.status === "rejected") doboz.appendChild(el("p", { class: "hint", text: jt(uiLang, "rejectedNote") }));

  if (Array.isArray(app.messages) && app.messages.length > 0) {
    doboz.appendChild(el("h3", { text: jt(uiLang, "messages") }));
    const lista = el("div", { class: "apply-messages" });
    for (const m of app.messages) {
      lista.appendChild(el("div", { class: "apply-message apply-message-" + m.from }, [
        el("div", { class: "hint", text: jt(uiLang, m.from === "organizer" ? "fromOrganizer" : "fromYou") + (m.at ? " · " + new Date(m.at).toLocaleString(model.locale || undefined) : "") }),
        el("div", { text: m.text }),
      ]));
    }
    doboz.appendChild(lista);
  }
  if (app.status === "moreInfo") {
    const valasz = el("textarea", { id: "apply-reply", class: "panel-input", rows: "3", maxlength: "1000" });
    valasz.value = model.valasz || "";
    valasz.addEventListener("input", () => kezelok.onReplyChange(valasz.value));
    doboz.appendChild(el("label", { class: "panel-label", for: "apply-reply", text: jt(uiLang, "reply") }));
    doboz.appendChild(valasz);
    doboz.appendChild(el("button", { type: "button", class: "primary-btn apply-reply-send", text: model.busy ? "…" : jt(uiLang, "sendReply"), disabled: model.busy === true, onclick: kezelok.onReply }));
  }
  if (Array.isArray(app.history) && app.history.length > 0) {
    doboz.appendChild(el("h3", { text: jt(uiLang, "history") }));
    const l = el("ul", { class: "apply-history" });
    for (const h of app.history) l.appendChild(el("li", { text: allapotFelirat(uiLang, h.status) + (h.at ? " · " + new Date(h.at).toLocaleString(model.locale || undefined) : "") }));
    doboz.appendChild(l);
  }
  if (app.status !== "withdrawn" || app.erased !== true) {
    const gombok = el("div", { class: "apply-withdraw" });
    if (app.status !== "withdrawn") gombok.appendChild(el("button", { type: "button", class: "neutral-btn apply-withdraw-btn", text: jt(uiLang, "withdraw"), disabled: model.busy === true, onclick: () => { if (window.confirm(jt(uiLang, "withdrawConfirm"))) kezelok.onWithdraw(false); } }));
    if (app.erased !== true) gombok.appendChild(el("button", { type: "button", class: "neutral-btn apply-erase-btn", text: jt(uiLang, "withdrawErase"), disabled: model.busy === true, onclick: () => { if (window.confirm(jt(uiLang, "eraseConfirm"))) kezelok.onWithdraw(true); } }));
    doboz.appendChild(gombok);
  }
  return doboz;
}

/**
 * @param {HTMLElement} app
 * @param {{uiLang:string, user:object|null, betolt:boolean, hiba:boolean, app:object|null, vazlat:object, lepes:string, hiany:string[], busy:boolean, kuldesHiba:boolean, valasz:string, locale?:string, nyelvvalaszto?:HTMLElement}} model
 * @param {object} kezelok onSignIn, onSignOut, onBackToApp, onRetryLoad, onChange, onRoles, onConsent, onNext, onBack, onSubmit, onReply, onReplyChange, onWithdraw
 */
export function renderJelentkezes(app, model, kezelok) {
  const uiLang = model.uiLang;
  app.innerHTML = "";
  app.className = "apply-page";
  const fej = el("div", { class: "top-bar apply-top" });
  if (model.nyelvvalaszto) fej.appendChild(model.nyelvvalaszto);
  if (model.user) {
    fej.appendChild(el("button", { type: "button", class: "text-btn apply-back-app", text: jt(uiLang, "backToApp"), onclick: kezelok.onBackToApp }));
    fej.appendChild(el("button", { type: "button", class: "text-btn", text: jt(uiLang, "signOut"), onclick: kezelok.onSignOut }));
  }
  app.appendChild(fej);

  const kartya = el("div", { class: "card apply-card" });
  kartya.appendChild(el("h1", { text: jt(uiLang, "title") }));

  if (!model.user) {
    kartya.appendChild(el("p", { text: jt(uiLang, "lead") }));
    kartya.appendChild(el("h3", { text: jt(uiLang, "roleTester") }));
    kartya.appendChild(el("p", { text: jt(uiLang, "roleTesterText") }));
    kartya.appendChild(el("h3", { text: jt(uiLang, "roleAdmin") }));
    kartya.appendChild(el("p", { text: jt(uiLang, "roleAdminText") }));
    kartya.appendChild(el("p", { class: "hint", text: jt(uiLang, "tools") }));
    kartya.appendChild(el("p", { class: "hint", text: jt(uiLang, "signInNote") }));
    kartya.appendChild(el("button", { type: "button", class: "primary-btn apply-start", text: jt(uiLang, "apply"), onclick: kezelok.onSignIn }));
  } else if (model.betolt) {
    kartya.appendChild(el("p", { class: "hint apply-loading", text: jt(uiLang, "loading") }));
  } else if (model.hiba) {
    kartya.appendChild(el("div", { class: "panel-status err apply-load-failed", text: jt(uiLang, "loadFailed") }));
    kartya.appendChild(el("button", { type: "button", class: "neutral-btn apply-retry", text: jt(uiLang, "retry"), onclick: kezelok.onRetryLoad }));
  } else if (model.app && model.app.exists && !["draft", "moreInfo_edit"].includes(model.app.status)) {
    kartya.appendChild(allapotOldal(uiLang, model, kezelok));
  } else if (model.lepes === "attekintes") {
    kartya.appendChild(attekintes(uiLang, model, kezelok));
  } else {
    kartya.appendChild(el("p", { text: jt(uiLang, "lead") }));
    kartya.appendChild(el("h2", { text: jt(uiLang, "formTitle") }));
    kartya.appendChild(urlap(uiLang, model, kezelok));
  }
  app.appendChild(kartya);
}

export const _internal = { SZOVEGES, KOZOS_KERDESEK, TESZTELO_KERDESEK, ADMIN_KERDESEK };
